export const COLORS = {
  nordicNature: [
    {
      name: 'Nøtt',
      src: 'https://assets.nobiadigital.com/image/upload/v1629981873/Marbodal/Kitchen%20model/Signatur%20Ekbacken/marbodal-signatur-ekbacken-kokso-hogskap.jpg',
    },
  ],
  nordicElegance: [
    {
      name: 'Valkaistu',
      src: 'Novart/Swatches/535_tammisäleovi_valkaistu_HR16.jpg',
    },
    {
      name: 'Lv',
      src: 'Novart/Swatches/529_tammisäleovi_lv_HR16.jpg',
    },
    {
      name: 'Musta',
      src: 'Novart/Swatches/53B_tammisäleovi_musta_HR16.jpg',
    },
  ],
  willa: [
    {
      name: 'Frost',
      src: 'Marbodal/Kök/Swatches/Swatch_Frost-vit.png',
    },
    {
      name: 'Moln',
      src: 'Marbodal/Kök/Swatches/Swatch_Moln.png',
    },
    {
      name: 'Aska',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_%C3%85ska.png',
    },
    {
      name: 'Bark',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Bark.png',
    },
    {
      name: 'Tall',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Tall.png',
    },
  ],
  maalatutSileat: [
    {
      name: 'Frost',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Frost-vit.png',
    },
    {
      name: 'Moln',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Moln.png',
    },
    {
      name: 'Aska',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_%C3%85ska.png',
    },
    {
      name: 'Bark',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Bark.png',
    },
    {
      name: 'Tall',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Tall.png',
    },
    {
      name: 'Hav',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Hav.png',
    },
    {
      name: 'Sand',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Sand.png',
    },
    {
      name: 'Frö',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Fr%C3%B6.png',
    },
    {
      name: '',
      src: 'Novart/Swatches/SAMMAL_trendiv%C3%A4ri_tummanvihre%C3%A4.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/USVA_trendiv%C3%A4ri_usvanvalkoinen.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/KARPALO_trendiv%C3%A4ri_punainen.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/L%C3%84HDE__96Y_sinivihre%C3%A4_HR5.jpg',
    },
  ],
  maalatutKehys: [
    {
      name: 'Frost',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Frost-vit.png',
    },
    {
      name: 'Moln',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Moln.png',
    },
    {
      name: 'Aska',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_%C3%85ska.png',
    },
    {
      name: 'Bark',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Bark.png',
    },
    {
      name: 'Tall',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Tall.png',
    },
    {
      name: 'Hav',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Hav.png',
    },
    {
      name: 'Sand',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Sand.png',
    },
    {
      name: 'Frö',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_Fr%C3%B6.png',
    },
    {
      name: '',
      src: 'Novart/Swatches/SAMMAL_trendiv%C3%A4ri_tummanvihre%C3%A4.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/USVA_trendiv%C3%A4ri_usvanvalkoinen.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/KARPALO_trendiv%C3%A4ri_punainen.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/L%C3%84HDE__96Y_sinivihre%C3%A4_HR5.jpg',
    },
  ],
  maalatutVedinuralliset: [
    {
      name: 'Frost',
      src: '/Marbodal/K%C3%B6k/Swatches/Swatch_Frost-vit.png',
    },
    {
      name: 'Aska',
      src: 'Marbodal/K%C3%B6k/Swatches/Swatch_%C3%85ska.png',
    },
  ],
  puujaViilu: [
    {
      name: '',
      src: 'Novart/Swatches/739_Luonnonvari_tammi_pystyviiluovi.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/73S_tammi_pystyviiluovi_valkaistutammi_HR13.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/733_tammi_pystyviiluovi_harmaa_HR11.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/73OA-Ruskea_tammi_pystyviiluovi.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/73B_tammi_pystyviiluovi_Musta_HR13.jpg',
    },
  ],
  melamiiniLaminaatti: [
    {
      name: '',
      src: 'Novart/Swatches/141_valkoinen_melamiiniovi_HR2.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/196_vaalea_tammi_melamiiniovi_HR2.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/168_mikrolaminaattiovi_ruskea-puusyy_HR5.jpg',
    },
  ],
  supermattalaminaatti: [
    {
      name: '',
      src: 'Novart/Swatches/439_valkoinen_supermattalaminaatti.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/441_musta_supermattalaminaatti.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/442_harmaa_supermattalaminaatti.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/443_vaaleaharmaa_supermattalaminaatti.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/447_pistaasinvihrea_supermattalaminaatti.jpg',
    },
    {
      name: '',
      src: 'Novart/Swatches/448_tummansininen_supermattalaminaatti.jpg',
    },
  ],
}

export const RANGES = {
  nordicNature:
    '/Marbodal/Kitchen%20model/Signatur%20Ekbacken/marbodal-signatur-ekbacken-kokso-hogskap.jpg',
  nordicElegance: '/Sigdal/Kitchens/Models/Eikeli/Sigdal-Eikeli-Lin-03.jpg',
  willa: 'Novart/Kitchen%20models/VantaanTammistonmyymala_Willa_2.jpg',
  maalatutSileat:
    'Marbodal/K%C3%B6k/Arkitekt%20Plus/Sand/Arkitektplus-beige-k%C3%B6k-Marbodal.jpg',
  maalatutKehys:
    'Marbodal/K%C3%B6k/Lind%C3%B6/Marbodal_Lind%C3%B6_sand_u-k%C3%B6k.jpg',
  maalatutVedinuralliset:
    'Marbodal/K%C3%B6k/Viken/marbodal_viken-aska-mellangra-marbodal_hero_224_RET.jpg',
  puujaViilu: 'Invita/Kitchens/Athena/invita_ry_new_001.jpg',
  melamiiniLaminaatti:
    'Marbodal/K%C3%B6k/Malevik/Malevik%20Brun%202022/marbodal_malevik_brun_kokso.jpg',
  supermattalaminaatti:
    'Novart/Customer%20kitchen/Asuntomessut_2022_Finnlog_1.jpg',
}

export const UNITS = {
  small: 'Novart/Price%20Configurator/Units/units-small.png',
  medium: 'Novart/Price%20Configurator/Units/units-medium.png',
  large: 'Novart/Price%20Configurator/Units/units-large.png',
}

export const WORKTOPS = {
  granite: 'Marbodal/Price%20Configurator/Worktops/granit.jpg',
  laminate: 'Marbodal/Price%20Configurator/Worktops/laminat.jpg',
  stainless: 'Marbodal/Price%20Configurator/Worktops/rostfri.jpg',
}
